module.exports = __webpack_public_path__ + "resources/035e8b4b319c1c6e843f8cbcc85d42e0.ttf";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/Compacta-Bd-BT-Roman.ttf
// module id = 239
// module chunks = 0